class ResetPasswordDelegate {
    setPassword(password) {
        this.setState({ password });
    }

    setConfirmPassword(confirmPassword) {
        this.setState({ confirmPassword });
    }
}

export default ResetPasswordDelegate;

